function initNotifyPlaceholders(root) {
  root.querySelectorAll('[data-notify-placeholder]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const msg = btn.parentElement?.querySelector('.gumball-drop__notify-msg');
      if (!msg) return;
      msg.hidden = false;
      window.setTimeout(() => {
        msg.hidden = true;
      }, 2500);
    });
  });
}

function initCarousel(carousel) {
  const track = carousel.querySelector('[data-gumball-track]');
  const prev = carousel.querySelector('[data-gumball-prev]');
  const next = carousel.querySelector('[data-gumball-next]');
  if (!track) return;

  const cards = () => Array.from(track.querySelectorAll('.gumball-drop__card'));
  const gap = () => parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '32', 10);

  const scrollAmount = () => {
    const card = cards()[0];
    return card ? card.offsetWidth + gap() : track.clientWidth * 0.8;
  };

  const updateNav = () => {
    const maxScroll = track.scrollWidth - track.clientWidth - 2;
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft >= maxScroll;

    if (prev) {
      prev.hidden = false;
      prev.disabled = atStart;
    }
    if (next) {
      next.hidden = false;
      next.disabled = atEnd;
    }
  };

  prev?.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  next?.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateNav, { passive: true });
  window.addEventListener('resize', updateNav);
  updateNav();
}

document.querySelectorAll('[data-gumball-carousel]').forEach((carousel) => {
  initCarousel(carousel);
  initNotifyPlaceholders(carousel.closest('.gumball-drop') || carousel);
});